/**
 * Generate a review card
 * @param {string} body
 * @param {string} date
 * @param {Array}  pictures
 * @param {number} rating
 * @param {string} name
 */
function generateUIProductReviewCard(body, date, pictures, rating, name) {
  const wrapper = document.querySelector('.reviews-slider__main');

  if (!wrapper) return;

  const ratingEl = window.theme.generateReviewStars(rating);
  const formattedDate = new Date(date).toLocaleDateString('en-GB');

  const fragment = document.createDocumentFragment();
  const div = document.createElement('div');
  div.className = 'product-reviews-slider__slide';
  div.innerHTML = `
    <!-- Reviewer Name -->
    <h3 class="reviews-slider__card-reviewer">
      ${window.theme.abbreviateName(name)}
    </h3>
    
    <div class="reviews-slider__card-rating-wrapper">
      <!-- Review Stars -->
      <div class="reviews-slider__card-rating">
        ${ratingEl}  
      </div>
      <span class="reviews-slider__card-separator"> | </span>
      <!-- Review Date -->
      <p class="reviews-slider__card-date">
        ${formattedDate}
      </p>
    </div>
    
    <!-- Review Text -->
    <p class="product-reviews-slider__card-text">${body}</p>

    <!-- Card Image -->
    <div class="product-reviews-slider__pictures--container">
      ${pictures
        .slice(0, 5)
        .map((picture) => {
          return `
            <a href="${picture.urls.original}" data-fancybox="product-reviews">
              <img src="${picture.urls.small}" width="40" height="40">
            </a>
          `;
        })
        .join('')}
    </div>
  `;

  window.Fancybox.bind('[data-fancybox="product-reviews"]');

  fragment.appendChild(div);
  wrapper.appendChild(fragment);
}
/**
 * Fetch the data and render the review card
 * @returns {Promise<void>}
 */
async function renderProductReviewsCards() {
  let page = 1;
  let publishedReviews = [];
  let newResponse;

  do {
    const productReviewsEl = document.querySelector('#product-reviews');
    const productId = productReviewsEl.getAttribute('data-product-id');
    if (!productId) return;
    try {
      // eslint-disable-next-line no-await-in-loop
      const results = await fetch(`/apps/judgeme-proxy/${productId}?page=${page}`);
      // eslint-disable-next-line no-await-in-loop
      const {reviews} = await results.json();
      newResponse = reviews;
      publishedReviews = [...publishedReviews, ...newResponse];
      page += 1;
    } catch (error) {
      console.log(error);
      document.querySelector('.reviews-slider').style.display = 'none';
    }
  } while (newResponse && newResponse.length !== 0);

  publishedReviews.sort((a, b) => b.pictures.length - a.pictures.length);
  publishedReviews = publishedReviews.filter((review) => review.published === true);

  if (!publishedReviews.length) return;

  publishedReviews.forEach(({body, created_at: createdAt, pictures, rating, reviewer: {name}}) =>
    generateUIProductReviewCard(body, createdAt, pictures, rating, name)
  );
}

/**
 * Initialize the slider and handle the custom buttons
 * @returns {Promise<void>}
 */
async function initProductReviewsSlider() {
  const skeleton = document.getElementById('reviews-slider-skeleton');
  const prevBtn = document.querySelector('#sl-product-reviews-arrows .arrow-previous');
  const nextBtn = document.querySelector('#sl-product-reviews-arrows .arrow-next');
  const mql = window.matchMedia('(min-width: 769px)').matches;

  if (!(prevBtn && nextBtn)) return;

  // Render the cards
  await renderProductReviewsCards();

  // Init the slider with options
  const slider = new Flickity('.reviews-slider__main', {
    groupCells: mql ? 4 : 1,
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    cellAlign: 'left',
    on: {
      ready() {
        this.element.classList.add('ready');
        skeleton.style.display = 'none';
        this.resize();
        nextBtn.disabled = this.slides.length <= 1;
      },
    },
  });

  // Custom previous slide button
  prevBtn.addEventListener('click', () => {
    slider.previous();
  });

  // Custom next slide button
  nextBtn.addEventListener('click', () => {
    slider.next();
  });

  // Disable the next/prev button if first or last slide
  slider.on('select', (index) => {
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === slider.slides.length - 1;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductReviewsSlider();
});
